export default __webpack_public_path__ + "static/media/AirCycle_Program_Banner_1034x600.29c04dfd.jpg";